export default "__VITE_ASSET__CPO5cntf__"